import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AddressFormComponent } from "../address-form/address-form.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { RouterModule } from "@angular/router";
import { AngularSvgIconModule } from "angular-svg-icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from '@angular/material/radio';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
    declarations: [
        AddressFormComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        RouterModule,
        AngularSvgIconModule,
        MatProgressSpinnerModule,
        PipesModule,
        MatRadioModule
    ],
    exports: [
        AddressFormComponent,
        MatRadioModule
    ],
})
export class ModalsModule {}
